export default __webpack_public_path__ + "static/media/lpf_sub20.557e3d2e.svg";